import { createRouter, createWebHistory } from 'vue-router'
import Index from '@/pages/Index.vue'
import Home from '@/pages/Home.vue'
import Acceptnotification from '@/pages/Acceptnotification.vue'
import Login from '@/pages/Login.vue'
import Register from '@/pages/Register.vue'
import Updateavailable from '@/pages/Updateavailable.vue'
import Welcome from '@/pages/Welcome.vue'
import SplashComponent from '@/components/appComponent/SplashComponent.vue'
import RegisterAfterSubscription from '@/pages/RegisterAfterSubscription.vue'
import Subscriptions from '@/pages/Subscriptions.vue'
// import ProductsView from '@/views/ProductsView.vue'
// import ProductDetails from '@/views/ProductDetails.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/acceptnotification',
      name: 'acceptnotification',
      component: Acceptnotification,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/registerAfterSubscription',
      name: 'registerAfterSubscription',
      component: RegisterAfterSubscription,
    },
    {
      path: '/updateavailable',
      name: 'updateavailable',
      component: Updateavailable,
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: Subscriptions,
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome,
    },{
      path: '/:pathMatch(.*)*',
      component: SplashComponent,
      meta: {
        hideHeader: true,
        hideFooter: true,
      },
    },
    // { path: '/category/:categoryId', component: ProductsView },
    // { path: '/product/:productId', component: ProductDetails },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (About.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('../views/AboutView.vue'),
    // },
  ],
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
